<template lang="html">
    <div class="adviceProject">
        <div class="project" v-for="item in list" :key="item.baseItemCode">
            <div class="parent">
                <div class="checkBox" v-if="item.goods.length > 0 || item.services.length > 0">
                    <Checkbox @click="checkboxParentChange({ baseItemCode: item.baseItemCode })"
                    v-model="item.is_selectd"
                    checked-color="#fd3833"></Checkbox>
                </div>
                <div class="info">
                    <p class="name" v-if="item.suggestedUnit">{{ item.baseItemName }}
                        <span class="dw">（{{ item.suggestedNum }} {{ item.suggestedUnit }}）</span>
                    </p>
                    <p class="name" v-else>{{ item.baseItemName }}
                        <span class="dw">（--）</span>
                    </p>
                    <p class="detail" v-if="item.suggest !==''">{{ item.suggest }}</p>
                </div>
            </div>

            <div v-if="(item.isShowAddGoods || item.isShowAddService) || (item.goods.length || item.services.length) ">
                <!-- 商品列表 -->
                <goodsProject
                    dataType="goods"
                    :baseItemCode="item.baseItemCode"
                    :childrenArr="item.goods"
                    @checkboxChildrenChange="checkboxChildrenChange"
                    @onGoodsDel="onGoodsDel"
                    @onChangeGoodsNumber="onChangeGoodsNumber"
                    @toGoodsDetail="(obj) => toGoodsDetail(Object.assign(obj, {
                        baseItemCode: item.baseItemCode
                    }))"
                    @onGoodsChange="(obj) => onAddGoods(Object.assign(obj, {
                        goodsType: 'changeGoods',
                        baseItemCode: item.baseItemCode,
                        maintain_cate_id: item.goods_cate_id,
                    }))"
                    @onGoodsSkuChange="onGoodsSkuChange"
                />

                <!-- 服务列表 -->
                <servicesProject
                    dataType="services"
                    :baseItemCode="item.baseItemCode"
                    :childrenArr="item.services"
                    :sstore_id="sstore_id"
                    @toServiceDetail="(obj) => toServiceDetail(Object.assign(obj, {
                        baseItemCode: item.baseItemCode
                    }))"
                    @checkboxChildrenChange="checkboxChildrenChange"
                    @onGoodsDel="onGoodsDel"
                />
            </div>
            <div class="sellout" v-else>
                门店暂无上架
            </div>

            <!-- 商品列表 -->
            <!-- <goodsProject
                dataType="goods"
                :baseItemCode="item.baseItemCode"
                :childrenArr="item.goods"
                @checkboxChildrenChange="checkboxChildrenChange"
                @onGoodsDel="onGoodsDel"
                @onChangeGoodsNumber="onChangeGoodsNumber"
                @toGoodsDetail="(obj) => toGoodsDetail(Object.assign(obj, {
                    baseItemCode: item.baseItemCode
                }))"
                @onGoodsChange="(obj) => onAddGoods(Object.assign(obj, {
                    goodsType: 'changeGoods',
                    baseItemCode: item.baseItemCode,
                    maintain_cate_id: item.goods_cate_id,
                }))"
                @onGoodsSkuChange="onGoodsSkuChange"
            /> -->

            <!-- 服务列表 -->
            <!-- <servicesProject
                dataType="services"
                :baseItemCode="item.baseItemCode"
                :childrenArr="item.services"
                :sstore_id="sstore_id"
                @toServiceDetail="(obj) => toServiceDetail(Object.assign(obj, {
                    baseItemCode: item.baseItemCode
                }))"
                @checkboxChildrenChange="checkboxChildrenChange"
                @onGoodsDel="onGoodsDel"
            /> -->

            <div class="projectFooter" @click="onAddGoods({
                baseItemCode: item.baseItemCode,
                maintain_cate_id: item.goods_cate_id,
                goodsType: 'addGoods',
            })" v-if="item.isShowAddGoods">添加商品</div>
            <div class="projectFooter" @click="onSelectServices({
                baseItemCode: item.baseItemCode,
                maintain_cate_id: item.services_cate_id
            })" v-if="item.isShowAddService">选择服务</div>
        </div>
    </div>
</template>
<script>
import {
    mapState,
    mapActions,
} from 'vuex'

import {
    Checkbox
} from 'vant'

import goodsProject from './goodsProject.vue'
import servicesProject from './servicesProject.vue'
import {
    getGoodsSkuInfo
} from '@/models/advice.js'

export default {
    name: 'adviceProject',
    inject: ['showLoading', 'hideLoading'],
    props: {
    },
    components: {
        Checkbox,
        goodsProject,
        servicesProject
    },
    data () {
        return {
            sstore_id: '' // 门店id
        }
    },
    computed: {
        ...mapState({
            vehicle_id: ({ advice }) => advice.vehicle_id, // 车型id
            adrive_list: ({ advice }) => advice.list, // 保养项目列表
            maintain_id: ({ advice }) => advice.maintain_id, // 保养id
        }),
        list: {
            get: function () {
                const driveList = JSON.parse(JSON.stringify(this.adrive_list))
                const newList = driveList.map((item) => {
                    // v2.5 优惠券版本
                    if (item.services.length > 0) {
                        for (var i = 0; i < item.services.length; i++) {
                            if (item.services[i].bc_coupon.length > 2) {
                                console.log(item.services[i].bc_coupon, 7777777)
                                item.services[i].bc_coupon = item.services[i].bc_coupon.slice(0, 2)
                            }
                        }
                    }
                    let isShowAddGoods = true
                    let isShowAddService = true
                    if (
                        // 机油类商品最多选择2个
                        ((item.is_cate_motor_oil === 1 && item['goods'].length === 2) || item['goods_on_sell'] === 0) ||
                        // 非机油类商品只能选择一个
                        ((item.is_cate_motor_oil === 0 && item['goods'].length === 1) || item['goods_on_sell'] === 0)
                    ) {
                        isShowAddGoods = false
                    }
                    if (item['services'].length >= 20 || item['services_on_sell'] === 0) {
                        isShowAddService = false
                    }
                    item.isShowAddGoods = isShowAddGoods
                    item.isShowAddService = isShowAddService
                    return item
                })
                return newList
            },
            set: function (newValue) {
                /* 更新 vuex */
                this.updateAdviceList(newValue)
            },
        }
    },
    watch:{
    },
    created () {
        /* 获取参数 */
        const { sstore_id } = this.$route.query
        this.sstore_id = sstore_id
    },
    methods:{
        ...mapActions([
            'verifyUserInfo',
            'updateAdviceList',
            'updateNowSelectGoods'
        ]),
        /*
         * 跳转服务详情
         */
        async toServiceDetail (obj) {
            await this.verifyUserInfo()
            /* 跳转服务详情 */
            this.$router.push({
                path: '/serviceDetail',
                query: {
                    ...obj,
                    source: 'advice',
                    noOnlyBuy: false
                }
            })
        },
        /**
         * 点击商品，跳转商品详情
         */
        async toGoodsDetail (obj) {
            await this.verifyUserInfo()
            this.$router.push({
                path: '/goodsDetail',
                query: {
                    goods_id: obj.id,
                    sstore_id: this.sstore_id,
                    maintain_id: this.maintain_id,
                    spu_id: obj.spu_id,
                    goods_type: obj.goods_type,
                    selected_num: obj.selected_num,
                    source: 'advice',
                    baseItemCode: obj.baseItemCode
                }
            })
        },
        /**
         * 选择服务
         */
        async onSelectServices (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            this.$router.push({
                path: '/selectService',
                query: {
                    maintain_cate_id: obj.maintain_cate_id, // 保养分类id
                    sstore_id: this.sstore_id, // 门店id
                    baseItemCode: obj.baseItemCode // 保养项目编码
                }
            })
        },
        /**
         * 添加商品 && 更换商品
         */
        async onAddGoods (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            this.$router.push({
                path: '/changeGoods',
                query: {
                    maintain_cate_id: obj.maintain_cate_id, // 保养分类id
                    sstore_id: this.sstore_id, // 门店id
                    baseItemCode: obj.baseItemCode, // 保养项目编码
                    goodsType: obj.goodsType,
                    goods_id: obj.childrenId
                }
            })
        },
        /**
         * 父节点 是否选择 更改
         */
        async checkboxParentChange (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            const newList = this.list.map((item) => {
                if (item.baseItemCode === obj.baseItemCode) {
                    item.is_selectd = Number(!item.is_selectd)
                    const goodsArr = item.goods.map((childrenItem) => {
                        childrenItem.is_selectd = item.is_selectd
                        return childrenItem
                    })
                    const servicesArr = item.services.map((childrenItem) => {
                        childrenItem.is_selectd = item.is_selectd
                        return childrenItem
                    })
                    item.goods = goodsArr
                    item.services = servicesArr
                }
                return item
            })
            this.list = newList
        },
        /**
         * 子节点 是否选择 更改
         */
        async checkboxChildrenChange (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            const newList = this.list.map((item, i) => {
                if (item.baseItemCode === obj.baseItemCode) {
                    /* 改变选择的某项 */
                    const newArr = item[obj.dataType].map((childrenItem, j) => {
                        /* 唯一标识 */
                        const childrenFlag = obj.dataType === 'goods' ? childrenItem.id : childrenItem.service_id
                        if (childrenFlag === obj.childrenId) {
                            childrenItem.is_selectd = Number(!childrenItem.is_selectd)
                        }
                        return childrenItem
                    })
                    item[obj.dataType] = newArr
                }
                return item
            })
            this.list = newList
        },
        /**
         * 删除商品
         * @param obj: {baseItemCode: 保养项目编码， childrenId：规格id，dataType: 类型}
         */
        async onGoodsDel (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            const list = JSON.parse(JSON.stringify(this.list))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                let project
                if (item.baseItemCode === obj.baseItemCode) {
                    project = item[obj.dataType]
                    for (let j = 0; j < project.length; j++) {
                        let childrenItem = project[j]
                        /* 唯一标识 */
                        const childrenFlag = obj.dataType === 'goods' ? childrenItem.id : childrenItem.service_id
                        if (childrenFlag === obj.childrenId) {
                            /* 核心 */
                            project.splice(j, 1)
                        }
                    }
                }
            }
            this.list = list
        },
        /**
         * 改变商品数量
         * @param obj: {
         *  baseItemCode: 保养项目编码，
         *  childrenId：规格id,
         *  dataType: 类型
         *  selected_num: 已选数量
         * }
         */
        async onChangeGoodsNumber (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            const list = JSON.parse(JSON.stringify(this.list))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                let project
                if (item.baseItemCode === obj.baseItemCode) {
                    project = item[obj.dataType]
                    for (let j = 0; j < project.length; j++) {
                        let childrenItem = project[j]
                        /* 唯一标识 */
                        const childrenFlag = obj.dataType === 'goods' ? childrenItem.id : childrenItem.service_id
                        if (childrenFlag === obj.childrenId) {
                            /* 核心 */
                            childrenItem.selected_num = obj.selected_num
                        }
                    }
                }
            }
            this.list = list
        },
        /**
         * 获取点击的索引
         */
        getClickIndex (obj) {
            const list = JSON.parse(JSON.stringify(this.list))
            for (let i = 0; i < list.length; i++) {
                const item = list[i]
                let project
                if (item.baseItemCode === obj.baseItemCode) {
                    /* 存储当前打开 父节点索引 */
                    sessionStorage.setItem('adviceParentIndex', i)
                    project = item[obj.dataType]
                    for (let j = 0; j < project.length; j++) {
                        let childrenItem = project[j]
                        /* 唯一标识 */
                        const childrenFlag = obj.dataType === 'goods' ? childrenItem.id : childrenItem.service_id
                        if (childrenFlag === obj.childrenId) {
                            /* 存储当前打开 子节点索引 */
                            sessionStorage.setItem('adviceChildrenIndex', j)
                        }
                    }
                }
            }
        },
        /**
         * 切换规格
         */
        async onGoodsSkuChange (obj) {
            /* 检查如果没登录，自动跳转登录 */
            await this.verifyUserInfo()
            /* 获取当前点击索引 */
            this.getClickIndex(obj)
            /* 更新vuex 的 当前选中商品数据 */
            this.updateNowSelectGoods(obj)
            /* 显示loading */
            this.showLoading()
            /* 获取参数 */
            const { sstore_id } = this.$route.query
            /* 请求接口 获取规格数据 */
            const skus = await getGoodsSkuInfo({
                sstore_id, // 门店id
                goods_type: obj.goods_type, // 商品类型（proprietary:自营，agent：代理）
                goods_id: obj.id, // 商品规格id
                spu_id: obj.spu_id, // 商品id
                vehicle_id: this.vehicle_id, // 车型id
            })
            /* 隐藏loading */
            this.hideLoading()
            /* 显示规格切换弹窗 */
            this.$emit('onShowSkuPopup', skus)
        },
        /**
         * 更换商品
         * @param obj: {baseItemCode: 保养项目编码， childrenId：规格id，dataType: 类型}
         */
        onGoodsChange (obj) {
            console.log('更换商品13122', obj)
        },
    }
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/stylus/variables.styl'
@import '~@/assets/stylus/mixin.styl'
.adviceProject
    width 100%
    .sellout
        padding 48px 0px
        text-align center
        color $textColor
        font-size $fontSmall
    .project
        border-bottom 10px solid #efefef
        .parent
            height 122px
            border-bottom 1px solid #efefef
            display flex
            justify-content center
            align-items center
            padding 0 30px
            .checkBox
                // width 106px
                margin-right 30px
                display flex
                justify-content center
            .info
                flex 1
                .name
                    color #3b3b3b
                    font-size 30px
                    line-height 45px
                    textOverflow()
                    .dw
                        color #666666
                        font-size 24px
                .detail
                    color #999999
                    font-size 24px
                    line-height 34px
                    textOverflow()
                    width 620px
        .projectFooter
            width 100%
            height 88px
            color #ff6600
            text-align center
            line-height 88px
            font-size 26px
            border-bottom 1px solid #efefef
    .project:last-child
        border-bottom none
</style>
